import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import { EffectFade,Autoplay, Pagination, Navigation } from "swiper";
import {motion} from 'framer-motion';
import Founder from "./Founder";
import Menu from "./Menu";
const Home = () => {
  const imgSrc = ["/sweets1.png","/sweets2.png", "/sweets3.png"];
  const options = {
    initial:{x:"-100%",opacity:0},
    whileInView:{
      x:0,
      opacity:1
    }
  }
  return (
   <>
    <section>
      <div>
        <div className="heading">
          <motion.h1 {...options}>Sweets Wala</motion.h1>
          <motion.p {...options}
            transition={{
              delay: 0.2,
            }}>Nature is the best healer.</motion.p>
          <motion.a href="#menu" initial={{y:"-100%",opacity:0}}  whileInView={{
            y: 0,
            opacity: 1,
          }}
          transition={{
            delay: 0.4,
          }}>
            Explore Menu
          </motion.a>
        </div>
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          effect={"fade"}
          autoplay={{
            delay: 5500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay, Pagination, Navigation, EffectFade]}
        >
          {imgSrc.map((img) => (
            <SwiperSlide>
              <img className="swiperImg" src={img} alt="slider_photo"/>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
    <Founder/>
    <Menu/>
   </>
  );
};

export default Home;
